import { LandingCTA } from "../components/LandingPage/LandingCTA"
import { LandingSuggested } from "../components/LandingPage/LandingSuggested"
import LoginForm from "../components/Login/LoginForm"

export const Login = () => {
    return <>
        <LoginForm />
    </>
}